// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== Launch poster modal ===== */
.launch-overlay {
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  /* Dim the rest of the page "a little" behind the poster */
  background: rgba(20, 12, 28, 0.6);
  backdrop-filter: blur(2px);
  animation: launch-fade 0.25s ease;
}

.launch-dialog {
  position: relative;
  max-width: 96vw;
  max-height: 88vh;
  animation: launch-pop 0.3s ease;
}

/* Two posters shown side by side */
.launch-posters {
  display: flex;
  gap: 16px;
  align-items: center;
  justify-content: center;
}

/* Posters are tall portraits (9:16) — constrain by height so both fit on
   screen, width follows the ratio. */
.launch-posters img {
  display: block;
  max-height: 84vh;
  max-width: 46vw;
  width: auto;
  height: auto;
  border-radius: 12px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.45);
}

/* Close button — top-right, just outside the poster corner */
.launch-close {
  position: absolute;
  top: -14px;
  right: -14px;
  width: 38px;
  height: 38px;
  border-radius: 50%;
  border: 2px solid #fff;
  background: #2a1a3a;
  color: #fff;
  font-size: 1.5rem;
  line-height: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
  transition: background 0.2s ease, transform 0.2s ease;
}

.launch-close:hover {
  background: #4a2a5a;
  transform: scale(1.08);
}

@keyframes launch-fade {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes launch-pop {
  from { opacity: 0; transform: scale(0.92); }
  to { opacity: 1; transform: scale(1); }
}

/* ===== Phone ===== */
@media (max-width: 640px) {
  .launch-overlay {
    padding: 12px;
  }

  .launch-posters {
    gap: 8px;
  }

  .launch-posters img {
    max-width: 47vw;
  }

  .launch-close {
    top: -10px;
    right: -10px;
    width: 34px;
    height: 34px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/frontend/components/LaunchModal/launch-modal.css"],"names":[],"mappings":"AAAA,oCAAoC;AACpC;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,0DAA0D;EAC1D,iCAAiC;EACjC,0BAA0B;EAC1B,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;qCACqC;AACrC;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA,6DAA6D;AAC7D;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yCAAyC;EACzC,qDAAqD;AACvD;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,OAAO,UAAU,EAAE,sBAAsB,EAAE;EAC3C,KAAK,UAAU,EAAE,mBAAmB,EAAE;AACxC;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,YAAY;IACZ,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":["/* ===== Launch poster modal ===== */\r\n.launch-overlay {\r\n  position: fixed;\r\n  inset: 0;\r\n  z-index: 1000;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 24px;\r\n  /* Dim the rest of the page \"a little\" behind the poster */\r\n  background: rgba(20, 12, 28, 0.6);\r\n  backdrop-filter: blur(2px);\r\n  animation: launch-fade 0.25s ease;\r\n}\r\n\r\n.launch-dialog {\r\n  position: relative;\r\n  max-width: 96vw;\r\n  max-height: 88vh;\r\n  animation: launch-pop 0.3s ease;\r\n}\r\n\r\n/* Two posters shown side by side */\r\n.launch-posters {\r\n  display: flex;\r\n  gap: 16px;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n/* Posters are tall portraits (9:16) — constrain by height so both fit on\r\n   screen, width follows the ratio. */\r\n.launch-posters img {\r\n  display: block;\r\n  max-height: 84vh;\r\n  max-width: 46vw;\r\n  width: auto;\r\n  height: auto;\r\n  border-radius: 12px;\r\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.45);\r\n}\r\n\r\n/* Close button — top-right, just outside the poster corner */\r\n.launch-close {\r\n  position: absolute;\r\n  top: -14px;\r\n  right: -14px;\r\n  width: 38px;\r\n  height: 38px;\r\n  border-radius: 50%;\r\n  border: 2px solid #fff;\r\n  background: #2a1a3a;\r\n  color: #fff;\r\n  font-size: 1.5rem;\r\n  line-height: 1;\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);\r\n  transition: background 0.2s ease, transform 0.2s ease;\r\n}\r\n\r\n.launch-close:hover {\r\n  background: #4a2a5a;\r\n  transform: scale(1.08);\r\n}\r\n\r\n@keyframes launch-fade {\r\n  from { opacity: 0; }\r\n  to { opacity: 1; }\r\n}\r\n\r\n@keyframes launch-pop {\r\n  from { opacity: 0; transform: scale(0.92); }\r\n  to { opacity: 1; transform: scale(1); }\r\n}\r\n\r\n/* ===== Phone ===== */\r\n@media (max-width: 640px) {\r\n  .launch-overlay {\r\n    padding: 12px;\r\n  }\r\n\r\n  .launch-posters {\r\n    gap: 8px;\r\n  }\r\n\r\n  .launch-posters img {\r\n    max-width: 47vw;\r\n  }\r\n\r\n  .launch-close {\r\n    top: -10px;\r\n    right: -10px;\r\n    width: 34px;\r\n    height: 34px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
